// import React from "react";
// import { getSupersetPieChart } from "../../../../docuclipper/api";
// import { useSelector } from "react-redux";
// import { ReduxState } from "../../../../redux";
// type Props = {};
// export const SupersetPieChart: React.FC<Props> = ({}) => {
//   const { job } = useSelector((state: ReduxState) => state.JobData);
//   React.useEffect(() => {
//     if (job && job.id) {
//       getSupersetPieChart(job.id).then((rsp) => console.log({ rsp }));
//     }
//   }, []);
//   return null;
// };
// export default SupersetPieChart;

import React, { useEffect, useRef, useState } from "react";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { getSupersetDashboard } from "../../../../docuclipper/api";
import { useSelector } from "react-redux";
import { ReduxState } from "../../../../redux";
import { setToken } from "../../../../redux/reducers/Auth";
// const token =
//   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7InVzZXJuYW1lIjoiQWRtaW4iLCJmaXJzdF9uYW1lIjoiYWRtaW4iLCJsYXN0X25hbWUiOiJhZG1pbiJ9LCJyZXNvdXJjZXMiOlt7InR5cGUiOiJkYXNoYm9hcmQiLCJpZCI6IjZjOGRmMzA0LWM1NjMtNDc5ZC1hMWEwLWU4M2JiMjBlZGRiZCJ9XSwicmxzX3J1bGVzIjpbeyJjbGF1c2UiOiJcImRvY3VtZW50SWRcIiBJTiAoMjM1NDA5OCkifV0sImlhdCI6MTcwMzgwMjQ0MS42NjkyNTMsImV4cCI6MTcwMzgwMjc0MS42NjkyNTMsImF1ZCI6Imh0dHA6Ly8wLjAuMC4wOjgwODAvIiwidHlwZSI6Imd1ZXN0In0.IbpZ9Qqk08K9oXSO39FFnuJGYX1f_I3lAyhfs9O05EY";

// const MySupersetDashboard = () => {
//   return (
//     <div
//       id="superset-container"
//       style={{ width: "100%", height: "600px" }}
//     ></div>
//   );
// };

// export default MySupersetDashboard;

const SupersetDash = ({ dashboardName, width, height, reload }) => {
  const supersetContainer = useRef(null);
  const { job } = useSelector((state: ReduxState) => state.JobData);
  const [token, setToken] = React.useState("");
  const [supersetDashboardId, setSupersetDashboardId] = React.useState("");
  useEffect(() => {
    if (job && job.id) {
      getSupersetDashboard(job.id, dashboardName)
        .then(({ supersetDashboardId, token }) => {
          setToken(token);
          setSupersetDashboardId(supersetDashboardId);
        })
        .catch((err) => null);
    }
  }, [job]);
  useEffect(() => {
    // async function fetchGuestToken() {
    //   try {
    //     const response = await axios.post("/superset/guest_token.json");
    //     return response.data.data;
    //   } catch (error) {
    //     console.error("Error while fetching guest token:", error);
    //     return null;
    //   }
    // }

    async function embedDashboardAsync(token, supersetDashboardId) {
      // const data = await fetchGuestToken();

      // console.log({ env: process.env.NODE_ENV });
      if (
        /*data && */ supersetContainer.current &&
        token &&
        supersetDashboardId
      ) {
        embedDashboard({
          id: supersetDashboardId, // given by the Superset embedding UI
          supersetDomain:
            process.env.NODE_ENV === "development"
              ? "http://localhost:8088"
              : "https://analytics.docuclipper.com",
          mountPoint: supersetContainer.current, // html element in which iframe render
          fetchGuestToken: () => Promise.resolve(token),
          dashboardUiConfig: { hideTitle: true },
        });

        // embedDashboard({
        //   id: data.dashboard_id,
        //   supersetDomain: data.domain,
        //   mountPoint: supersetContainer.current,
        //   fetchGuestToken: () => data.token,
        //   dashboardUiConfig: {
        //     hideTitle: true,
        //     filters: {
        //       expanded: true,
        //     },
        //   },
        // });

        const iframe = (supersetContainer.current as any).querySelector(
          "iframe"
        );

        if (iframe) {
          iframe.style.width = width;
          iframe.style.height = height;
          // iframe.style.width = "100%";
          // iframe.style.height = "800px";
        }
      }
    }

    if (reload) {
      embedDashboardAsync(token, supersetDashboardId);
    }
  }, [supersetContainer, token, supersetDashboardId, reload]);

  return (
    <React.Fragment>
      <div className="superset-container" ref={supersetContainer}></div>
    </React.Fragment>
  );
};

export default SupersetDash;
